import { createFileRoute, redirect } from '@tanstack/react-router'
import { sessionQueryOptions } from '@/entities/session'
import { SignInForm } from '@/features/auth'

export const Route = createFileRoute('/login')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions)
    if (session) throw redirect({ to: '/schedule' })
  },
  component: LoginPage,
})

function LoginPage() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-8 px-6 pt-safe-16 pb-safe-16">
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="label">voron</span>
        <h1 className="t-h2">Кабинет команды</h1>
      </div>
      <SignInForm />
    </div>
  )
}
